import React from 'react';
import { StyleSheet, Text, View } from './components/base_components';

import { BusyOverlay, useBusy } from './components/busy_component';
import Breadcrumb from './components/breadcrumb';
import ProgressSpinner from './components/progress_spinner';
import OrgTabBar from './components/org_tab_bar';
import StandardBoxList from './components/standard_box_list';
import Plan from './components/plan';
import PlanList from './components/plan_list';

import OrgStore from './stores/org_store';
import UserStore from './stores/user_store';

const styles = StyleSheet.create({
  orgPlanScreen: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
  },
  spinner: { margin: '3rem', alignSelf: 'center' },
  tabBar: { marginLeft: '2.2rem', marginRight: '2.2rem' },
  plan: { margin: '2rem' },
  planList: { justifyContent: 'flex-start' },
  dialog: { marginLeft: '2rem', marginBottom: '2rem', flexDirection: 'column' },
  text: { marginTop: '1em', fontSize: '1.5em' },
});

export default function OrgPlanScreen() {
  const [is_busy, setBusy, clearBusy] = useBusy();
  const org_id = UserStore.useOrg()?.org_id;
  const org = OrgStore.useOrg(org_id);

  React.useEffect(() => {
    OrgStore.fetch(org_id);
  }, [org_id]);

  function _onPlanPress(new_plan) {
    const { plan_id, plan_name } = new_plan;
    const yes = window.confirm(
      `Are you sure you want to change your plan to ${plan_name}?`
    );
    if (yes && setBusy()) {
      OrgStore.updatePlan({ org_id, plan_id }, (err) => {
        clearBusy();
        if (err) {
          window.alert('Plan update failed, please try again.');
        }
      });
    }
  }

  let content: any = null;
  if (!org) {
    content = <ProgressSpinner style={styles.spinner} color='#555' />;
  } else {
    content = (
      <>
        <Breadcrumb list={[{ text: org?.org_name, url: `/org` }, 'Plan']} />
        <OrgTabBar style={styles.tabBar} />
        <StandardBoxList title='Current Plan'>
          {org.plan ? <Plan style={styles.plan} plan={org.plan} /> : null}
        </StandardBoxList>
        <StandardBoxList title='Change Plan'>
          {org.plan?.is_self_signup === 0 ? (
            <View style={styles.dialog}>
              <Text style={styles.text}>
                Please contract your sales representative to change your plan.
              </Text>
            </View>
          ) : (
            <PlanList
              style={styles.planList}
              excludePlan={org.plan}
              onPress={_onPlanPress}
            />
          )}
        </StandardBoxList>
      </>
    );
  }
  return (
    <View style={styles.orgPlanScreen}>
      {content}
      <BusyOverlay isBusy={is_busy} />
    </View>
  );
}
